import { render } from "./reviewConfirmationModal.vue?vue&type=template&id=812a5fe4"
import script from "./reviewConfirmationModal.vue?vue&type=script&lang=js"
export * from "./reviewConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__